export default "__VITE_ASSET__C1FpfGd4__"